import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutGrid2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-grid-2, grid"} maskId="square-filled-radius-0-stroke-1-IconLayoutGrid2"><path d="M3 3V11H11V3H3Z" fill="currentColor"/><path d="M13 3V11H21V3H13Z" fill="currentColor"/><path d="M3 13V21H11V13H3Z" fill="currentColor"/><path d="M13 13V21H21V13H13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutGrid2;
